import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IReqPublishSetting {
    id?: number,
    companyId?: number,
    branchId?: number,
    roleId?: number,
    publishBySkill?: boolean,
    publishInBranch?: boolean,
    publishInCompany?: boolean,
    publishGlobally?: boolean,
    company_Name?: string,
    branchName?: string,
    role_Name?: string,
}

export interface IModel {
    open: boolean,
    singleData: IReqPublishSetting
}

export const EmptySetting: IReqPublishSetting = {
    companyId: 0,
    branchId: 0,
    roleId: 0,
    publishBySkill: false,
    publishInBranch: false,
    publishInCompany: false,
    publishGlobally: false
}

export const ReqPublishSetting = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptySetting, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptySetting, open: false })
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    );
}
